import { getTableDataFromCache, saveStaffPicturesToCache, saveTablesToCache } from "utils/offlineCache";

const syncEndpoints = [
  "/goods/stocks",
  "/goods/wares",
  "/equipments",
  "/staff",
  "/staff/occupations",
  "/staff/crew",
  "/staff/list",
  "/services",
  "/services/by-day",
  "/entry/occupancy",
  "/goods/sales",
];

export const downloadAutoSyncData = async ({ apiClient, onProgress }) => {
  try {
    if (!apiClient) {
      return { status: false, data: "API client is required" };
    }

    const reportProgress = (message) => {
      if (typeof onProgress === "function") {
        onProgress(message);
      }
    };

    for (const endpoint of syncEndpoints) {
      reportProgress(`A sincronizar ${endpoint}...`);
      if (endpoint === "/goods/stocks") {
        const countedStocks = await getTableDataFromCache("countedStocks");
        // this was deleting the stocks table that had a count on it and was causing the movements to disappear from the list, resulting in the loss of movements made
        if (countedStocks.status === true && countedStocks.data.length > 0) {
          continue;
        }
      }
      const fetchResponse = await apiClient.getMany(endpoint);
      if (fetchResponse.status === false) {
        return { status: false, data: { table: endpoint, message: fetchResponse.data } };
      }

      reportProgress(`A guardar cache ${endpoint}...`);
      const cacheResponse = await saveTablesToCache(endpoint, fetchResponse.data);
      if (cacheResponse.status === false) {
        return { status: false, data: { table: endpoint, message: cacheResponse.data } };
      }

      if (endpoint === "/staff/list") {
        reportProgress("A guardar imagens do staff...");
        await saveStaffPicturesToCache(fetchResponse.data || [], {
          onProgress: (message) => reportProgress(message),
        });
      }
    }

    return { status: true, data: "OK" };
  } catch (error) {
    return { status: false, data: "Unexpected error downloading sync data" };
  }
};
